export const ValueStatus = {
    active: 1,
    desactive: 2,
    delete: 3,
    disponible: 4,
    indisponible: 5,
    enCours: 6,
    publie: 7,
};
